import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import type { BravadoSelectDropdownOption } from './types';
import BravadoSelectDropdownImage from './BravadoSelectDropdownImage.vue';
import CheckIcon from '@/assets/svg/check.vue.svg';

type BravadoSelectDropdownItemProps = {
  option: BravadoSelectDropdownOption;
  isSelected?: boolean;
  removable?: boolean;
};
type BravadoSelectDropdownItemEmits = {
  (event: 'toggle-option', payload: MouseEvent): void;
  (event: 'keydown', payload: KeyboardEvent): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'BravadoSelectDropdownItem',
  props: {
    option: null,
    isSelected: { type: Boolean, default: false },
    removable: { type: Boolean, default: true }
  },
  emits: ["toggle-option", "keydown"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'toggle-option', payload: MouseEvent): void;
  (event: 'keydown', payload: KeyboardEvent): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { option: BravadoSelectDropdownOption, isSelected: boolean, removable: boolean };




function handleToggleOption(event: MouseEvent) {
  emit('toggle-option', event);
}

function handleKeyEvent(event: KeyboardEvent) {
  emit('keydown', event);
}

const itemClasses = computed(() => ({
  'bravado-select-dropdown-item': true,
  'bravado-select-dropdown-item--with-helper-text': !!props.option.selectDropdownHelperText,
  'bravado-select-dropdown-item--not-removable': !props.removable,
}));
const textClasses = computed(() => ({
  'bravado-select-dropdown-item__text': true,
  'bravado-select-dropdown-item__text--not-removable': !props.removable,
}));
const checkClasses = computed(() => ({
  'bravado-select-dropdown-item__check': true,
  'bravado-select-dropdown-item__check--not-removable': !props.removable,
}));

return { __sfc: true,props, emit, handleToggleOption, handleKeyEvent, itemClasses, textClasses, checkClasses, BravadoSelectDropdownImage, CheckIcon }
}

})